angular
    .module('MW.v11n.MapService', [
        'CoreColorService'
    ])
    .factory('MapService', [
        'CoreColorService',
        function(CoreColorService) {
            var mapServiceObj = {},
                colorPalettes = {
                orange: [
                    [0, CoreColorService.colors.yellowLight],
                    [0.01, CoreColorService.colors.yellow],
                    [0.4, CoreColorService.colors.yellowDark],
                    [1, CoreColorService.colors.orange]]
                }

            mapServiceObj.colorPalettes = colorPalettes;
            return mapServiceObj;
}]);